import { Create } from '@fund/api-modules';
// import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';
import TransformResponse from './decorator/TransformResponse';
import cfhInfoModel from '../model/cfh-info.model';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      customerno: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  // baseURL: 'https://fundcfhapi.1234567.com.cn', // getApiHostWithoutEnv('fundcfhapi2'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  baseURL: 'https://dataapineice.1234567.com.cn',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    ServerVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class CFHApi {
  getFundVarietyByFundCode(FCODE) {
    // return this.GET('/cfhapp/CFHData/app/FundVarietyByFundCode', {
    //   fundcode: FCODE,
    // });
    return this.GET('cfh/prompt/readbyfund', {
      code: FCODE,
      linktype: 0,
    }, {
      baseURL: 'https://uni-fundts.1234567.com.cn/',
    });
  }

  @TransformResponse((res) => cfhInfoModel.objectWithKeyValues(res?.data || {}))
  getReadByFund(FCODE) {
    return this.GET('cfh/prompt/readbyfund', {
      code: FCODE,
      linktype: 0,
    }, {
      baseURL: 'https://uni-fundts.1234567.com.cn/',
      // baseURL: 'https://dataapineice.1234567.com.cn',
    });
  }

  getCouponCard(giftid) {
    return this.GET('/cfhapp/CFHData/gift/CouponCard', {
      giftid,
    });
  }
}
export default new CFHApi();
